import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/services/api';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import EmailTemplatesManager from './EmailTemplatesManager';

export default function EmailTemplatesTab() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  const [selectedClientId, setSelectedClientId] = useState<number | ''>('');
  const clientId = isAdmin ? (selectedClientId || undefined) : (user?.client_id ?? undefined);

  const { data: clients = [], isLoading: loadingClients } = useQuery<{ id: number; legal_name?: string; trade_name?: string }[]>({
    queryKey: ['email-clients'],
    queryFn: async () => {
      const d = await api.getClients();
      return Array.isArray(d) ? d : [];
    },
    enabled: isAdmin,
  });

  return (
    <div className="space-y-6">
      {isAdmin && (
        <Card>
          <CardHeader><CardTitle>Cliente</CardTitle></CardHeader>
          <CardContent>
            <Select
              value={selectedClientId ? String(selectedClientId) : ''}
              onValueChange={(v) => setSelectedClientId(v ? Number(v) : '')}
              disabled={loadingClients}
            >
              <SelectTrigger>
                <SelectValue placeholder={loadingClients ? 'Carregando...' : 'Selecione o cliente'} />
              </SelectTrigger>
              <SelectContent>
                {clients.map((c) => (
                  <SelectItem key={c.id} value={String(c.id)}>
                    {c.trade_name || c.legal_name || `Cliente ${c.id}`}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </CardContent>
        </Card>
      )}
      <EmailTemplatesManager key={clientId ?? 'none'} clientId={clientId} />
    </div>
  );
}
